function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer>
      <div className="wrap footer-inner">
        <span>© {year} shreyansh koladiya</span>
        <span>built with react + typescript ❤️</span>
      </div>
    </footer>
  );
}

export default Footer;
